var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("div", { staticClass: "grid-container" }, [
          _c(
            "div",
            { staticClass: "grid-x grid-margin-x align-center align-middle" },
            [
              _c(
                "div",
                { staticClass: "cell small-auto medium-2" },
                [
                  _c("v-datepicker", {
                    staticClass:
                      "form-control form-control--small form-control--date",
                    attrs: {
                      id: "pickdate",
                      placeholder: _vm.$t("search.from"),
                      format:
                        _vm.$t("search.from") + " " + _vm.$helpers.dateFormat,
                      clearButton: true,
                      "disabled-dates": _vm.$helpers.disabledDates,
                      language: _vm.de,
                      "monday-first": true,
                    },
                    model: {
                      value: _vm.calendar.startdate,
                      callback: function ($$v) {
                        _vm.$set(_vm.calendar, "startdate", $$v)
                      },
                      expression: "calendar.startdate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cell small-auto medium-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { role: "button", type: "submit", title: "Ändern" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onChangeCalendarDate.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Datum Auswählen")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell small-auto medium-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button--prev button--calendar",
                    attrs: {
                      role: "button",
                      type: "submit",
                      title: _vm.$t("backward"),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.getPrevCalendar.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("backward")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button button--next button--calendar",
                    attrs: {
                      role: "button",
                      type: "submit",
                      title: _vm.$t("forward"),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.getNextCalendar.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("forward")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell small-auto medium-1" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.viewsize,
                        expression: "viewsize",
                      },
                    ],
                    attrs: {
                      name: "viewsize",
                      title: "Darstellung Einstellung",
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.viewsize = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.viewSize,
                      ],
                    },
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v("Skalierung"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [_vm._v("100%")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: ".95" } }, [_vm._v("95%")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: ".90" } }, [_vm._v("90%")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: ".85" } }, [_vm._v("85%")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: ".80" } }, [_vm._v("80%")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: ".75" } }, [_vm._v("75%")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: ".70" } }, [_vm._v("70%")]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-container full", style: _vm.scaling }, [
          _c("div", { staticClass: "grid-x grid-margin-x text-center" }, [
            _c("div", { staticClass: "cell auto" }, [
              _c(
                "div",
                { staticClass: "c-calendar-slider" },
                _vm._l(this.dates, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "c-calendar-slider__item box" },
                    [
                      _c("v-week-group", {
                        attrs: {
                          startdate: item,
                          index: index,
                          holidays: _vm.holidays,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "grid-container u-extra-medium-margin--top u-extra-medium-margin--bottom text-center",
            },
            [
              _c("h2", { staticClass: "u-extra-small-margin--bottom" }, [
                _vm._v(_vm._s(_vm.$t("weeks.parkinglot.title"))),
              ]),
              _vm._v(" "),
              _c(
                "draggable",
                {
                  staticClass: "c-parking-lot-wrapper",
                  attrs: {
                    tag: "div",
                    animation: "150",
                    group: "week",
                    draggable: ".c-parking-lot-item",
                    sort: false,
                    "data-parkinglot": 1,
                  },
                  on: { end: _vm.onEndDrag },
                  model: {
                    value: _vm.parked_entries,
                    callback: function ($$v) {
                      _vm.parked_entries = $$v
                    },
                    expression: "parked_entries",
                  },
                },
                [
                  _vm.parked_entries.length === 0
                    ? _c("div", { staticClass: "text-center empty-message" }, [
                        _vm._v(_vm._s(_vm.$t("weeks.parkinglot.empty"))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.parked_entries, function (entry) {
                    return _c(
                      "div",
                      {
                        key: entry.id,
                        staticClass: "c-parking-lot-item",
                        attrs: {
                          "data-entry_id": entry.id,
                          "data-date": _vm
                            .$moment(entry.startdate)
                            .format("YYYY-MM-DD"),
                          "data-kolonne": entry.kolonne,
                        },
                      },
                      [
                        entry.project
                          ? [
                              _c("span", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(entry.project.customer.company_name)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(entry.project.address.city)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "u-subtil-link",
                                  attrs: {
                                    to: {
                                      name: "customers-update-customer-project",
                                      params: {
                                        customer:
                                          entry.project.customer.company_id,
                                        project: entry.project_id,
                                      },
                                    },
                                    title: _vm.$t("update"),
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(entry.project.project_number)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "router-link",
                                {
                                  staticClass: "u-subtil-link",
                                  attrs: {
                                    to: {
                                      name: "update-tour",
                                      params: { tour: entry.tour_id },
                                    },
                                    title: _vm.$t("update"),
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(entry.tour.tour_number)),
                                  ]),
                                ]
                              ),
                            ],
                        _vm._v(" "),
                        _c("v-week-day-content-day-graphic", {
                          attrs: { numberOfDays: _vm.calcNumberOfDays(entry) },
                        }),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }